import PropTypes from "prop-types";

/**
 * PropTypes for Admin Users view.
 */
export const adminUsersPropTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
};
